import { IDictionary } from '~utilities/IDictionary';
import ConditionalSigningStatusEnum from './ConditionalSigningStatusEnum';

export const conditionalSigningStatusTagLabels: IDictionary<string> = {
    [ConditionalSigningStatusEnum.AwaitingSignature]: 'Awaiting Signature',
    [ConditionalSigningStatusEnum.Cancelled]: 'Signing Cancelled',
    [ConditionalSigningStatusEnum.Expired]: 'Signing Expired',
    [ConditionalSigningStatusEnum.Failed]: 'Signing Failed',
    [ConditionalSigningStatusEnum.PartiallySigned]: 'Partially Signed',
    [ConditionalSigningStatusEnum.Signed]: 'Signed',
};